module.exports = __webpack_public_path__ + "media/images/lb/578-5aa27e607d4f68a46ef22e117d226c34.svg";